import { render } from "./AppInvoice.vue?vue&type=template&id=3587dc16&scoped=true&lang=pug"
import script from "./AppInvoice.vue?vue&type=script&lang=js"
export * from "./AppInvoice.vue?vue&type=script&lang=js"

import "./AppInvoice.vue?vue&type=style&index=0&id=3587dc16&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3587dc16"]])

export default __exports__